import axiosInstance from "api/axiosInstance";
import { toast } from "react-toastify";
import { showToast } from "toast/toastHelper";

export const userSettlementList = async (accessToken) => {
    try {
        const response = await axiosInstance.get(
            "/business/@me/settlement/list",
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );

        return response.data;

    } catch (error) {
        console.error(
            "Error fetching settlement list:",
            error
        );

        toast.error(
            error?.response?.data?.message ||
            "خطا در دریافت تاریخچه درخواست‌های تسویه"
        );

        throw error;
    }
};


export const userSettlementSubmit = async (
    accessToken,
    amount,
    cardNumber,
    iban
) => {
    try {
        const response = await axiosInstance.post(
            "/business/@me/settlement/manual-request",
            {
                amount: amount,
                cardNumber: cardNumber,
                iban: `IR${iban}`,
            },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
        
        return response.data;

    } catch (error) {
        showToast(error.response.data.error,"error")
    }
};
